import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromEtlReducer from '@etl/etl.reducer';
import * as etlSelectors from '@etl/etl.selectors';
import { Observable, Subscription } from 'rxjs';
import * as fromModels from '@models';
import { faRandom, faFilter } from '@fortawesome/free-solid-svg-icons';
import { Location } from '@angular/common';
import * as etlActions from '@etl/etl.actions';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';
import * as fromUtils from '@utils';
import { ActivatedRoute } from '@angular/router';
import { ModuleService } from '@base/module/module.service';
import { CompanyService } from '@base/company/company.service';
import { IModule } from '@interfaces';
import { ICompany } from '@company/company.structures';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.sass']
})
export class DetailsComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  private routeModuleId: number = fromUtils.EMPTY;
  private routeCompanyId: number = fromUtils.EMPTY;
  private routeJobId: number = fromUtils.EMPTY;
  private modules: IModule[];
  private companies: ICompany[];
  private currentModule: IModule;
  currentCompany: ICompany;
  faRandom = faRandom;
  job: Observable<fromModels.Etl> = null;
  isFetching: Observable<boolean>;
  errorInfo: Observable<object> = null;

  constructor(
    private _location: Location,
    private store: Store<{etls: fromEtlReducer.EtlState}>,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private moduleService: ModuleService,
    private companyService: CompanyService,
  ) {
    const modSubs = this.moduleService.observeCurrentModule().subscribe((m: IModule) => this.currentModule = m);
    const coSubs = this.moduleService.observeCurrentCompany().subscribe((c: ICompany) => this.currentCompany = c);
    const allModules = this.moduleService.observeModules().subscribe(
      (res: IModule[]) => {
        this.modules = res;
        this.loadInstanceInfo(this.routeModuleId, this.modules as [], this.currentModule);
      }
    );

    const allCompanies = this.companyService.observeCompanies().subscribe(
      (res: ICompany[]) => {
        this.companies = res;
        this.loadInstanceInfo(this.routeCompanyId, this.companies as [], this.currentCompany, fromUtils.COMPANY);
      }
    );

    this.subscriptions = [...this.subscriptions, allModules, allCompanies, modSubs, coSubs, ];
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.routeModuleId = fromUtils.getNumber(params['id']);
      this.routeCompanyId = fromUtils.getNumber(params['companyId']);
      this.routeJobId = fromUtils.getNumber(params['jobId']);
      this.loadInstanceInfo(this.routeModuleId, this.modules as [], this.currentModule);
      this.loadInstanceInfo(this.routeCompanyId, this.companies as [], this.currentCompany, fromUtils.COMPANY);

      const etl = new fromModels.Etl();
      etl.id = this.routeJobId;
      this.store.dispatch(etlActions.jobDetails({row: etl}));
    });
    this.job = this.store.select(etlSelectors.jobDetails).pipe(
      map((res: object) => {
        const row: fromModels.Etl = res['row'];
        return row;
      })
    );
    this.isFetching = this.store.select(etlSelectors.fetchingCollection);
    this.errorInfo = this.store.select(etlSelectors.getError);

    this.subscriptions = [...this.subscriptions, ];
  }

  ngOnDestroy() {
    this.subscriptions.map(s => s.unsubscribe());
  }

  private loadInstanceInfo(
    id: number, collection: [], currentInstance: object, subject = fromUtils.MODULE
  ) {
    const instance = fromUtils.loadInstanceOf(id, collection, currentInstance);
    if (instance !== fromUtils.EMPTY) {
      if (subject === fromUtils.MODULE) {this.moduleService.setCurrentModule(instance); }
      if (subject === fromUtils.COMPANY) {this.moduleService.setCompany(instance); }
    }
  }

  goToList() {
    this._location.back();
  }

  refreshDetails(jobObs: Observable<fromModels.Etl>) {
    jobObs.pipe(
      map(res => res)
    ).subscribe((job: fromModels.Etl) => {
      this.store.dispatch(etlActions.jobDetails({row: job}));
    });
  }

  private openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 4000,
    });
  }
}
